import {TranslateSvc} from './TranslateSvc';

export class OurFeedbackSvc {
    private feedbacks: IFeedBackDefinition[] = [
        ...(_.range(1, 6).map<IFeedBackDefinition>((n: number) => ({
            product: 'STUDIO',
            pages: ['studio-pricing'],
            name: `pricing.feedback${n}.author`,
            company: `pricing.feedback${n}.author.position`,
            twit: `pricing.feedback${n}`
        }))),
        {
            product: 'STUDIO',
            pages: ['studio-landing-banner', 'studio-landing-explainer'],
            name: 'landing.startup.feedback2.author',
            company: 'landing.startup.feedback2.author.position',
            twit: 'landing.startup.feedback2'
        },
        {
            product: 'STUDIO',
            pages: ['studio-landing-banner', 'studio-landing-explainer'],
            name: 'landing.startup.feedback3.author',
            company: 'landing.startup.feedback3.author.position',
            twit: 'landing.startup.feedback3'
        },
        {
            product: 'STUDIO',
            pages: ['studio-landing-banner'],
            name: 'landing.everyone.feedback4.author',
            company: 'landing.everyone.feedback4.author.position',
            twit: 'landing.everyone.feedback4'
        },
        {
            product: 'STUDIO',
            pages: ['studio-landing-banner'],
            name: 'landing.everyone.feedback5.author',
            company: 'landing.everyone.feedback5.author.position',
            twit: 'landing.everyone.feedback5'
        },
        {
            product: 'STUDIO',
            pages: ['studio-landing-banner'],
            name: 'landing.everyone.feedback6.author',
            company: 'landing.everyone.feedback6.author.position',
            twit: 'landing.everyone.feedback6'
        },
        {
            product: 'STUDIO',
            pages: ['studio-landing-explainer'],
            name: 'landing.startup.feedback1.author',
            company: 'landing.startup.feedback1.author.position',
            twit: 'landing.startup.feedback1'
        },
        {
            id: 'smith1',
            product: 'WAVE',
            avatar: 'mari-smith.png',
            name: 'wave.feedback-slider.author-name-1',
            company: 'wave.feedback-slider.author-description-1',
            twit: 'wave.feedback-slider.content-1',
            link: '/videos-for-social-media-mari-smith',
            tutorial: 'wave.feedback-slider.mari-smith.tutorial'
        },
        {
            id: 'daniel1',
            avatar: 'daniel.jpg',
            product: 'WAVE',
            name: 'wave.feedback-slider.author-name-2',
            company: 'wave.feedback-slider.author-description-2',
            twit: 'wave.feedback-slider.content-2'
        },
        {
            id: 'aandpete1',
            avatar: 'aandpete1.jpg',
            product: 'WAVE',
            name: 'wave.feedback-slider.author-name-3',
            company: 'wave.feedback-slider.author-description-3',
            twit: 'wave.feedback-slider.content-3'
        },
        {
            product: 'ANY',
            name: 'landing.everyone.feedback7.author',
            company: 'landing.everyone.feedback7.author.position',
            twit: 'landing.everyone.feedback7'
        },
        {
            product: 'ANY',
            avatar: 'ean.png',
            name: 'pricing.feedback4.author',
            company: 'pricing.feedback4.author.position',
            twit: 'pricing.feedback4'
        },
        {
            product: 'ANY',
            name: 'landing.everyone.feedback2.author',
            company: 'landing.everyone.feedback2.author.position',
            twit: 'landing.everyone.feedback2'
        },
        {
            product: 'ANY',
            name: 'pricing.feedback1.author',
            avatar: 'ixe.png',
            company: 'pricing.feedback1.author.position',
            twit: 'pricing.feedback1'
        }
    ];

    constructor(private $state: ng.ui.IStateService,
                private TranslateSvc: TranslateSvc) {
    }

    getByIds(feedbackIds: string[]) {
        const list = this.feedbacks.filter(fb => fb.id && feedbackIds.includes(fb.id));
        return this.map(list);
    }

    getFor(product: AnimatronProduct) {
        const list = this.feedbacks.filter(fb => fb.product && fb.product === product);
        return this.map(list);
    }

    getForPage(): Array<IFeedBackDefinition> {
        const list = this.feedbacks.filter(fb => fb.pages && fb.pages.includes(this.$state.current.name as FeedbackPage));
        return this.map(list);
    }

    private map(list: IFeedBackDefinition[]) {
        const noTranslationProp = ['product', 'avatar', 'id', 'link'];

        return list.map((fb: IFeedBackDefinition) =>
            _.mapObject<IFeedBackDefinition>(fb, (value, key) =>
                _.isString(value) && !noTranslationProp.includes(key) ? this.TranslateSvc.get(value) : value));
    }
}

angular.module('animatronApp.feedback').service('OurFeedbackSvc', OurFeedbackSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/OurFeedbackSvc.ts